import { find } from "lodash";
import OnboardingSteps from "../enums/Step";
export default function shouldRedirectToGDPR(_a) {
    var completedSteps = _a.completedSteps;
    var hasDoneGDPRStep = find(completedSteps, function (step) { return step === OnboardingSteps.ACCEPT_GDPR; });
    return !hasDoneGDPRStep;
}
